import { formatNumber } from "./numberFormatter";

export const KILOGRAM_FACTOR = 1000;
export const POUND_FACTOR = 2204.6226218;
export const TONNES_TO_TONS_FACTOR = 1.10231;
export const POUNDS_TO_TONS_FACTOR = 1 / 2000;
export const KILOGRAM_TO_TONS_FACTOR = 1 / 907.185;
export const UNIT_KILOGRAM_SYMBOL = 'kg';
export const UNIT_POUND_SYMBOL = 'lb';
export const UNIT_METRIC_TONNE_SYMBOL = 't';
export const KM_FACTOR = 1;
export const MILES_FACTOR = 0.621371;
export const TREES_FACTOR = 20;

export const convertToTonne = (value: number, fromUnit: string) => {
  if (!fromUnit) return null;

  const symbol = fromUnit.toLowerCase();
  if (symbol === UNIT_METRIC_TONNE_SYMBOL) return value;

  if (symbol === UNIT_KILOGRAM_SYMBOL) return value / KILOGRAM_FACTOR;
  else if (symbol === UNIT_POUND_SYMBOL) return value / POUND_FACTOR;
};

export const convertToKG = (value: number, fromUnit: string): number => {
  const symbol = fromUnit.toLowerCase();
  if (symbol === UNIT_KILOGRAM_SYMBOL) return value;
  else if (symbol === UNIT_METRIC_TONNE_SYMBOL) return value * KILOGRAM_FACTOR;
  else throw new Error("Unknown mass unit symbol: " + fromUnit);
};

export const convertMassToKg = (mass: {value: number; unit: string}): number => {
  return convertToKG(mass.value, mass.unit);
}

export const getPriceInKgPerProduct = (selectedAmount: { value: number; unit: string }) => {
  let value;
  value = convertToKG(selectedAmount.value, selectedAmount.unit);
  return `${
    Number(value)?.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) || '-'
  } ${UNIT_KILOGRAM_SYMBOL}`;
};

export const carbonKilogramsToTrees = (impact?: number) => {
  if (!impact) {
    return;
  }

  const treesNumber = Math.trunc(impact / TREES_FACTOR);
  return formatNumber(treesNumber);
};